import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  EditPermanentServiceMutation,
  EditPermanentServiceMutationVariables,
  EditPermanentServiceDocument,
  FetchTenderByIdDocument,
  FetchServicesOnTenderDocument,
} from "@/graphql/__generated__/graphql";

export default function useEditPermanentServiceMutationHook(options?: {
  disableToast?: boolean;
  disableRefetch?: boolean;
}): { editPermanentServiceMutation: any; loading: any; error: any } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [editPermanentServiceMutation, { loading, error }] = useMutation<EditPermanentServiceMutation, EditPermanentServiceMutationVariables>(
    EditPermanentServiceDocument, {
      onCompleted() {
        if (!options?.disableToast) {
          toast(CustomToastComponent, {
            toastId: "permanent-service-updated-success",
            data: {
              title: t("toasts.permanentserviceupdated"),
              type: "success",
            },
          });
        }
      },
      refetchQueries: options?.disableRefetch
        ? []
        : [
          {
            query: FetchTenderByIdDocument,
            variables: { id: Number(tenderID) },
          },
          {
            query: FetchServicesOnTenderDocument,
            variables: { tenderId: Number(tenderID) },
          },
        ],
    });

  return {
    editPermanentServiceMutation,
    loading,
    error,
  };
}
